import {ClientMessageRoomsState} from "../store/client_message_rooms_state";
import {Reducer} from "redux";
import {
    ClientMessageRoomsAction,
    ClientMessageRoomsActionType,
} from "../action/client_message_rooms_action";

const initialState: ClientMessageRoomsState = {
    messageRooms: [],
    customers: [],
    projects: [],
    latestMessages: [],
    initialMessageRoom: null,
    contracts: [],
    isLoading: false,
};

const clientMessageRoomsReducer: Reducer<ClientMessageRoomsState> = (state = initialState, action: ClientMessageRoomsAction): ClientMessageRoomsState => {
    switch (action.type) {
        case ClientMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }

        case ClientMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    messageRooms: action.item ? action.item.messageRooms : [],
                    customers: action.item ? action.item.customers : [],
                    projects: action.item ? action.item.projects : [],
                    latestMessages: action.item ? action.item.latestMessages : [],
                    initialMessageRoom: action.item ? action.item.initialMessageRoom : null,
                    contracts: action.item ? action.item.contracts : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientMessageRoomsReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_message_rooms_reducer.ts